export const Entitlements = {
  MEMBERSHIP_REFERRAL: 'MEMBERSHIP_REFERRAL',
  NEW_MESSAGE: 'NEW_MESSAGE',
} as const;

export type Entitlements = typeof Entitlements[keyof typeof Entitlements];
